import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vimeo-iframe__thumbnail-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "vimeo-iframe__icon-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "vimeo-iframe__icon" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "60",
      height: "65",
      viewBox: "0 0 60 65",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M56.6434 28.0552C60.1789 30.0308 60.1789 34.9698 56.6434 36.9454L8.91389 63.6163C5.37838 65.5919 0.958984 63.1224 0.958984 59.1712L0.958987 5.82943C0.958987 1.87819 5.37838 -0.591331 8.9139 1.38429L56.6434 28.0552Z",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_4 = ["autoplay", "loop", "muted", "playsinline"]
const _hoisted_5 = ["src"]

import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressPreviewPlayer',
  props: {
  videoThumbnailUrl: {
    type: String,
    required: false,
  },
  vimeoId: {
    type: String,
    required: true,
  },
  loop: {
    type: Boolean,
    required: false,
    default: false,
  },
  muted: {
    type: Boolean,
    required: false,
    default: false,
  },
  autoplay: {
    type: Boolean,
    required: false,
    default: false,
  },
  playsinline: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: {
  play: () => true,
},
  setup(__props, { emit: emits }) {

const props = __props;



const playerRef = ref<HTMLMediaElement>();
const loop = ref(props.loop);
const muted = ref(props.muted);
const autoplay = ref(props.autoplay);
const playsinline = ref(props.playsinline);



const onClick = () => {
  emits("play");
};

onMounted(() => {
  if (!playerRef.value) {
    return;
  }

  const video = playerRef.value;
  const originalMutedState = video.muted;

  if (video.autoplay && video.paused) {
    if (!video.muted) {
      video.muted = true;
    }

    const promise = video.play();

    promise.catch(() => {
      // Autoplay not allowed!
      // Mute video and try to play again
      video.play();
    });

    video.muted = originalMutedState;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "video-player2",
    onClick: onClick
  }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!autoplay.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (__props.videoThumbnailUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    alt: "",
                    class: "vimeo-iframe__thumbnail",
                    src: __props.videoThumbnailUrl
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true),
              _hoisted_3
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("video", {
      class: "video-player2__video",
      autoplay: autoplay.value,
      loop: loop.value,
      muted: muted.value,
      playsinline: playsinline.value,
      ref_key: "playerRef",
      ref: playerRef,
      onClick: onClick
    }, [
      _createElementVNode("source", {
        src: __props.vimeoId.toString(),
        type: "video/mp4"
      }, null, 8, _hoisted_5),
      _createTextVNode(" Your browser does not support the video tag. ")
    ], 8, _hoisted_4)
  ]))
}
}

})